import { Component, ViewChild, ViewEncapsulation } from '@angular/core';
import { BreakpointObserver, Breakpoints, BreakpointState } from '@angular/cdk/layout';
import { MatDrawer, MatDrawerMode, MatDrawerToggleResult, MatSidenav } from '@angular/material/sidenav';
import { Router } from '@angular/router';
import { PermissionService } from '../../../auth/permission.service';


@Component({
  selector: 'app-sidenav',
  templateUrl: './sidenav.component.html',
  styleUrls: ['./sidenav.component.scss'],
  encapsulation: ViewEncapsulation.None,
  standalone: false
})
export class SidenavComponent {

  @ViewChild('sidenav', { static: false }) sidenav!: MatSidenav;
  mode: MatDrawerMode = 'side'; //| 'over' = 'side';
  isExpanded: boolean;
  isHandset: boolean = false;
  showRewardMenu: boolean = false;
  userData: any = null;

  permissions: any[] = [];

  constructor(private breakpointObserver: BreakpointObserver, private permissionService: PermissionService, private router: Router) {
    this.isExpanded = false;
    const userDetailsData = sessionStorage.getItem('user');
    if (userDetailsData) {
      this.userData = JSON.parse(userDetailsData);
    }
  }


  ngOnInit(): void {
    this.permissions = this.permissionService.getPermission();
    // No sidenav usage here
  }

  isViewerMode(): boolean {
    return this.router.url.includes('/roster/viewer');
  }

  ngAfterViewInit(): void {
    this.breakpointObserver.observe(['(max-width: 768px)']).subscribe((state: BreakpointState) => {
      if (this.isViewerMode()) {
        this.sidenav?.close();
        return;
      }
      if (state.matches) {
        this.mode = 'over';
        this.sidenav.close();
        this.isHandset = true;
        this.isExpanded = true;
      } else {
        this.mode = 'side';
        this.sidenav.open();
        this.isHandset = false;
        this.isExpanded = false;
      }
    });
  }

  /**
   * Check if main menu has access
   * @param menuTitle 
   * @returns 
   */
  hasAccess(menuTitle: string): boolean {
    // return true;
    if (!this.permissions) {
      return false;
    }
    const menuPermissions = this.permissions.filter((p: any) => p.main_menu === menuTitle);

    if (menuPermissions.length === 0) {
      return false;
    }
    return menuPermissions.some((p: any) => p.permission.can_view == 1);
  }

  hasPageAccess(page: string): boolean {
    return this.permissionService.hasPermission(page, 'view');
  }

  getDefaultRouterLink(menuTitle: string): string {
    // return true;
    if (!this.permissions) {
      return '/access-denied';
    }
    const menuPermissions = this.permissions.filter((p: any) => p.main_menu === menuTitle);

    if (menuPermissions.length === 0) {
      return '/access-denied';
    }
    const menus = menuPermissions.filter((p: any) => p.permission.can_view == 1);
    return menus.length > 0 ? menuTitle.toLowerCase() + '/' + menus[0].page.toLowerCase() : '/access-denied';
  }

  isActive(test: string | string[]): boolean {
    const url = this.router.url;
    if (Array.isArray(test)) {
      return test.some(t => url.startsWith(t));
    }
    return url.startsWith(test);
  }

  closeSidenav(): void {

    if (this.isHandset) {
      this.sidenav.close();
    } else {
      // this.isExpanded = false;
    }
  }

  toggleSidenav(): void {

    if (this.isHandset) {
      this.sidenav.toggle().then((result: MatDrawerToggleResult) => {
        if (!result) {
          this.sidenav.close();
        }
      });
    } else {
      this.sidenav.close();

      setTimeout(() => {
        this.isExpanded = !this.isExpanded;
        this.sidenav.open();
      }, 250);

    }

  }
}
